let isModalShowing = false;

export function showSessionExpiredModal() {
  // Prevent multiple modals from stacking
  if (isModalShowing) return;
  isModalShowing = true;

  // Clear auth data immediately
  localStorage.removeItem('token');
  localStorage.removeItem('user');

  const TIMEOUT_SECONDS = 30;
  let remaining = TIMEOUT_SECONDS;

  // Create overlay
  const overlay = document.createElement('div');
  overlay.id = 'session-expired-overlay';
  Object.assign(overlay.style, {
    position: 'fixed',
    inset: '0',
    zIndex: '99999',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    backdropFilter: 'blur(4px)',
  });

  // Create modal
  const modal = document.createElement('div');
  Object.assign(modal.style, {
    backgroundColor: '#ffffff',
    borderRadius: '12px',
    padding: '32px',
    maxWidth: '420px',
    width: '90%',
    boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)',
    textAlign: 'center',
    fontFamily: 'system-ui, -apple-system, sans-serif',
  });

  modal.innerHTML = `
    <div style="margin-bottom: 20px;">
      <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#f59e0b" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="margin: 0 auto;">
        <circle cx="12" cy="12" r="10"/>
        <line x1="12" y1="8" x2="12" y2="12"/>
        <line x1="12" y1="16" x2="12.01" y2="16"/>
      </svg>
    </div>
    <h2 style="margin: 0 0 12px; font-size: 20px; font-weight: 600; color: #111827;">
      Session Expired
    </h2>
    <p style="margin: 0 0 8px; font-size: 14px; color: #6b7280; line-height: 1.5;">
      Your current session has expired. This may be because the same account was signed in on a different device or browser, causing this session to become inactive.
    </p>
    <p style="margin: 0 0 24px; font-size: 13px; color: #9ca3af;">
      Redirecting to login in <span id="session-countdown" style="font-weight: 600; color: #f59e0b;">${remaining}</span> seconds...
    </p>
    <button id="session-login-btn" style="
      display: inline-flex;
      align-items: center;
      justify-content: center;
      padding: 10px 32px;
      background-color: #2563eb;
      color: #ffffff;
      border: none;
      border-radius: 8px;
      font-size: 14px;
      font-weight: 500;
      cursor: pointer;
      transition: background-color 0.15s;
    ">
      Login
    </button>
  `;

  overlay.appendChild(modal);
  document.body.appendChild(overlay);

  // Wire up the Login button
  const loginBtn = document.getElementById('session-login-btn');
  const goToLogin = () => {
    clearInterval(timer);
    isModalShowing = false;
    window.location.href = '/login';
  };
  loginBtn?.addEventListener('click', goToLogin);
  loginBtn?.addEventListener('mouseenter', () => {
    loginBtn.style.backgroundColor = '#1d4ed8';
  });
  loginBtn?.addEventListener('mouseleave', () => {
    loginBtn.style.backgroundColor = '#2563eb';
  });

  // Countdown timer
  const countdownEl = document.getElementById('session-countdown');
  const timer = setInterval(() => {
    remaining -= 1;
    if (countdownEl) countdownEl.textContent = String(remaining);
    if (remaining <= 0) {
      goToLogin();
    }
  }, 1000);
}
